<template>
  <!-- Car Testimonial -->
  <section class="car-testimonial common-padding">
    <div class="container">
      <div class="row aos" data-aos="zoom-in">
        <div class="col-lg-4 col-md-6">
          <div class="car-testimonial-content">
            <h3>.01</h3>
            <h5>FIND THE CAR IN YOUR DREAM</h5>
            <p>
              With the function search of listee, you can find the exactly any
              type of car that you want in a few minutes. Fast & Exactly !
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="car-testimonial-content">
            <h3>.02</h3>
            <h5>CHECK PRICE AND INFORMATION OF VEHICLE</h5>
            <p>
              Check price and informations about vehicle. You can also estimate
              your payment with our Financial Caculator
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="car-testimonial-content">
            <h3>.03</h3>
            <h5>BOOK APPOINTMENTS WITH A TAP</h5>
            <p>
              Easy to make an appointments with agents or dealers. Agents or
              dealers will call again for you in 24h
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Car Testimonial -->

  <!-- Browse By Brand -->
  <section class="browse-by-brand common-padding">
    <div class="car-float-bg aos" data-aos="fade-down">
      <img src="@/assets/img/brand-bg.png" alt="" />
      <img src="@/assets/img/brand-bg-2.png" alt="" />
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="home-six-heading-section">
            <div
              class="home-six-title d-flex justify-content-center align-items-center"
            >
              <h2>Browse By Make</h2>
              <img src="@/assets/img/icons/title.svg" alt="" />
            </div>
            <p>
              Rutrum ante tempus mauris facilisi, leo faucibus, egestas
              diamlorem malesu, vitae mauris.
            </p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-10 col-md-12">
          <div class="car-class-carousel">
            <div class="car-brand-slider owl-carousel owl-theme">
              <Carousel
                :wrap-around="true"
                :settings="settings"
                :breakpoints="breakpoints"
              >
                <Slide v-for="item in IndexSixTestimonial" :key="item.id">
                  <router-link to="categories">
                    <div class="browse-by-brand-item aos" data-aos="flip-left">
                      <img
                        :src="require(`@/assets/img/partners/${item.image}`)"
                        alt=""
                      />
                      <p>
                        {{ item.title }} <span>{{ item.text }}</span>
                      </p>
                    </div>
                  </router-link>
                </Slide>
                <template #addons>
                  <Pagination />
                </template>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Browse By Brand -->
</template>
<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import IndexSixTestimonial from "@/assets/json/indexSixTestimonial.json";
export default {
  data() {
    return {
      IndexSixTestimonial: IndexSixTestimonial,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 991 and up
        991: {
          itemsToShow: 5,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 5,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>
<style></style>
